import { Component } from '@angular/core';

@Component({
  selector: 'app-card-info-beneficiary',
  templateUrl: './card-info-beneficiary.component.html',
  styleUrls: ['./card-info-beneficiary.component.scss'],
})
export class CardInfoBeneficiaryComponent {
  beneficiaries = [
    {
      name: 'Guisela Andrea Contreras Peña',
      rut: '12.006.475-9',
      birthdate: 'Mon Mar 04 1985 00:00:00 GMT-0500 (hora estándar de Perú)',
      relationship: 'Madre',
      healthCareSystem: 'Sistema de Salud',
    },
  ];
}
